import { Action } from '@ngrx/store';
import { CustomerGroupsChangeNotification } from '@appRoot/core/customer/models';


export enum ActionTypes {
    RESET = '[Customer groups Change Notifications storage] RESET',
    ADD_ONE = '[Customer groups Change Notifications storage] ADD_ONE',
    UPSERT_ONE = '[Customer groups Change Notifications storage] UPSERT_ONE',
    UPSERT_MANY = '[Customer groups Change Notifications storage] UPSERT_MANY',
    UPDATE_ONE = '[Customer groups Change Notifications storage] UPDATE_ONE',
    REMOVE_ONE = '[Customer groups Change Notifications storage] REMOVE_ONE',
    REMOVE_MANY = '[Customer groups Change Notifications storage] REMOVE_MANY',
}

export class Reset implements Action {
    readonly type = ActionTypes.RESET;
}

export class AddOne implements Action {
    readonly type = ActionTypes.ADD_ONE;

    constructor(readonly payload: CustomerGroupsChangeNotification) { }
}

export class UpsertOne implements Action {
    readonly type = ActionTypes.UPSERT_ONE;

    constructor(readonly payload: CustomerGroupsChangeNotification) { }
}

export class UpsertMany implements Action {
    readonly type = ActionTypes.UPSERT_MANY;

    constructor(readonly payload: CustomerGroupsChangeNotification[]) { }
}

export class UpdateOne implements Action {
    readonly type = ActionTypes.UPDATE_ONE;

    constructor(readonly payload: CustomerGroupsChangeNotification) { }
}

export class RemoveOne implements Action {
    readonly type = ActionTypes.REMOVE_ONE;

    constructor(readonly payload: CustomerGroupsChangeNotification) { }
}

export class RemoveMany implements Action {
    readonly type = ActionTypes.REMOVE_MANY;

    constructor(readonly payload: CustomerGroupsChangeNotification[]) { }
}


export type Actions =
    | Reset
    | AddOne
    | UpsertOne
    | UpsertMany
    | UpdateOne
    | RemoveOne
    | RemoveMany
    ;
